import { GenericDataType } from "./GenericDataType";
import { PlotReducer } from "./PlotReducer";
import { PlotValueConverter } from "./PlotValueConverter";

export class PlotAxisDefinition {
    field: string;
    reducer: PlotReducer = PlotReducer.none;
    valueConverter: PlotValueConverter = PlotValueConverter.none;
    scriptConverter: string;
    dataType: GenericDataType = GenericDataType.string;
    field2: string;
}
